import { render } from "./filter-results.vue?vue&type=template&id=47c34a33"
import script from "./filter-results.vue?vue&type=script&lang=js"
export * from "./filter-results.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__